import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import shared from '../../../utils/shared.js';

const QuillDeltaToHtmlConverter = require('quill-delta-to-html'); 
class StoryTampa extends Component {

  constructor(props) {
    super(props);

    this._subscribeModule = null;
    this._showBackground = true;

    if (this.props.showBackground !== undefined) {
      this._showBackground = this.props.showBackground;
    }

    this.state = {
      image: null,
      dimensions: null
    }
  }

  async componentDidMount() {
    const imageObj = new Image();
    const imagePath = shared.dp(this.props.screen, this.props.story.contents.images[0]);
    imageObj.src = imagePath;
    const dimensions = await new Promise((resolve, reject) => {
      imageObj.onload = function() {
        return resolve({ width: this.width, height: this.height });
      }
    });
    this.setState({
      image: imagePath,
      dimensions: dimensions
    })
  }

  redirect = () => {
    if (this._subscribeModule !== null && this._subscribeModule !== undefined) {
      this.props.navRoute('/tampa/subscribe', this._subscribeModule);
    }
  }

  render() {
    let backgroundImage = null;
    const unit = this.props.screen.r9_16.p10 / this.props.screensNumber;
    const maxAbsoluteBlockWidth = (this.props.screen.screenWidth / this.props.screensNumber * 0.85) - (this.props.screen.screenHeight * 0.0268 * 2);

    const imageStyle = {
      height: '33vh',
      width: '85%',
      borderTopLeftRadius: "3.125vh",
      borderTopRightRadius: "3.125vh",
      margin: "auto",
      overflow:"hidden"
      // backgroundSize: "cover",
      // backgroundPosition:"center",
      // backgroundRepeat: "no-repeat"
    };

    let imagePath = shared.dp(this.props.screen, this.props.story.contents.images[0]);
    if (this.props.showBackground) {
      backgroundImage = this.props.backgroundImage;
    }
    const backgroundSize = `${this.props.screen.screenWidth}px ${this.props.screen.screenHeight}px`;
    let bodyOps = _.get(this.props.story, 'contents.custom_fields.body.val.ops', _.get(this.props.story, 'contents.custom_fields.body.default.ops', null));
    let bodyRichText = new QuillDeltaToHtmlConverter(bodyOps, {}).convert();
    // let titleOps = _.get(this.props.story, 'contents.custom_fields.title.val.ops', _.get(this.props.story, 'contents.custom_fields.title.default.ops', null));
    // let titleRichText = new QuillDeltaToHtmlConverter(titleOps, {}).convert();

    let maxWidth = 0, maxHeight = 0, verticalAlign = "middle";
    if (this.state.dimensions) {
      const ratio = this.state.dimensions.width / this.state.dimensions.height;
      if (this.state.dimensions.width > this.state.dimensions.height) {
        verticalAlign = "bottom";
        maxWidth = this.state.dimensions.width;
        maxHeight = this.state.dimensions.height;
        if (this.state.dimensions.width > this.props.screen.screenWidth * .85) {
          maxWidth = this.props.screen.screenWidth * .85;
          maxHeight = maxWidth / ratio;
        }
      } else {
        maxHeight = this.props.screen.screenHeight * .33;
        maxWidth = maxHeight * ratio;
      }
    }

    const imageHeight = maxHeight > this.props.screen.screenHeight * .33 ? maxHeight : this.props.screen.screenHeight * .33;
    const bodyHeight = 100 - (5 + (imageHeight / this.props.screen.screenHeight * 100) + 5);
    return (
      <div style={{ width: this.props.screen.screenWidth / this.props.screensNumber, height:this.props.screen.screenHeight, backgroundImage:"url("+backgroundImage+")", backgroundSize: backgroundSize }}>
        <div style={{ top:"5vh", position:"absolute", width: this.props.screen.screenWidth / this.props.screensNumber, height: "100vh" }} >
          <div style={{ display: "block", margin: "auto" }}>
            <div style={{ ...imageStyle, backgroundColor: "white", textAlign:"center", display: "table" }}>
              <div style={{ display: "table-cell", verticalAlign: verticalAlign }}> 
                <img src={imagePath} style={{ width: maxWidth, height: maxHeight, margin: "auto" }} alt=""/>
              </div>
            </div>
          </div>

          {/* <div>
            <img alt="Stripe" style={{ display: "block", margin: "auto", height: this.props.screen.r9_16.height * .004, width: "85%" }} src={"/img/miami/general/rainbowuistrip.png"} />
          </div> */}

          <div style={{ display: 'block', margin: "auto", height: bodyHeight + "vh", width: '85%', backgroundColor: 'white', borderBottomLeftRadius: "3.125vh", borderBottomRightRadius: "3.125vh", }}>
            <div style={{ fontSize: '2.25vh', textAlign: "left", marginLeft: unit * .5, fontFamily: "opensans-bold", color: '#404040' }}>
            </div>
            <div style={{ height:"1.12vh" }}/>
            {/* <div style={{ fontSize: '1.96875vh', textAlign: "left", fontFamily: "opensans-bold", paddingRight:"2.68vh", paddingLeft:"2.68vh", paddingTop:"1.5vh",paddingBottom:"0.4921875vh",color:"#404040" }}>
              {this.props.story.contents.headline}
            </div> */}
            <div style={{ height: "39vh", paddingTop:"0.4921875vh", paddingLeft:"2.68vh", paddingRight:"2.68vh", paddingBottom:"1.68vh", display:"table", textAlign:"justify", position:"absolute", width:maxAbsoluteBlockWidth }}>
              <div style={{ width:"100%", position:"relative", marginBottom: "1vh" }}>
                <div className="ql-editor" style={{ fontSize:"2vh", overflowY: 'hidden', lineHeight: "2.5vh", color: "#0f3464" }}>
                  <p>{this.props.story.name}</p>
                </div>
              </div>
              <div style={{ width:"100%", position:"relative" }}>
                <div className="ql-editor" style={{ maxHeight:"38.5vh", fontSize: '1vh', overflowY: 'hidden',  lineHeight:"1.302083333vh", color:"#404040"  }} dangerouslySetInnerHTML={{ __html: bodyRichText }}/>
              </div>
            </div>
            <br />
          </div>
        </div>
      </div>
    )
  }
}


const mapStateToProps = (state) => {
  return {
    stories: state.content.stories,
    screen: state.screen
  };
};

export default connect(mapStateToProps, null)(StoryTampa);



// WEBPACK FOOTER //
// ./src/Components/Theme/Tampa/StoryTampa.jsx